var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import { PlayMode } from '../player';
export var DinPlayerContext = createContext({});
export function DinPlayerProvider(_a) {
    var children = _a.children, _b = _a.audioSetName, audioSetName = _b === void 0 ? 'en_us_digits' : _b, _c = _a.extraAudioSetNames, extraAudioSetNames = _c === void 0 ? [] : _c, _d = _a.playMode, playMode = _d === void 0 ? PlayMode.BinauralOutOfPhase : _d;
    var _e = useState({}), player = _e[0], setPlayer = _e[1];
    var _f = useState(false), initialized = _f[0], setInitialized = _f[1];
    return (_jsx(DinPlayerContext.Provider, __assign({ value: {
            player: player,
            setPlayer: setPlayer,
            initialized: initialized,
            setInitialized: setInitialized,
            audioSetName: audioSetName,
            extraAudioSetNames: extraAudioSetNames,
            playMode: playMode,
        } }, { children: children })));
}
export default DinPlayerProvider;
